module.exports = __webpack_public_path__ + "static/media/charmaine_brimm.510565a1.pdf";